export const combineCustomAttributeElements = (
  staticElements,
  customAttributeElements,
  savedOrder = []
) => {
  const staticElementsBeforeAttributes = staticElements.filter(
    element => !element.afterAttributeLabel && !element.replaceAttributeLabel
  );
  const anchoredStaticElements = staticElements.filter(
    element => element.afterAttributeLabel || element.replaceAttributeLabel
  );
  const allElements = [
    ...staticElementsBeforeAttributes,
    ...customAttributeElements,
    ...anchoredStaticElements,
  ];

  if (savedOrder.length) {
    allElements.sort((a, b) => {
      const aPosition = savedOrder.indexOf(a.key);
      const bPosition = savedOrder.indexOf(b.key);

      if (aPosition === -1 && bPosition === -1) return 0;
      if (aPosition === -1) return 1;
      if (bPosition === -1) return -1;

      return aPosition - bPosition;
    });
  }

  const groups = new Map();
  anchoredStaticElements.forEach(element => {
    const operation = element.replaceAttributeLabel ? 'replace' : 'after';
    const anchorLabel =
      element.replaceAttributeLabel || element.afterAttributeLabel;
    const groupKey = `${operation}:${anchorLabel}`;
    const group = groups.get(groupKey) || {
      operation,
      anchorLabel,
      elements: [],
    };
    group.elements.push(element);
    groups.set(groupKey, group);
  });

  groups.forEach(({ operation, anchorLabel, elements }) => {
    const movableKeys = new Set(
      elements
        .filter(element => !savedOrder.includes(element.key))
        .map(({ key }) => key)
    );
    const movableElements = allElements.filter(({ key }) =>
      movableKeys.has(key)
    );
    movableElements.forEach(element => {
      allElements.splice(allElements.indexOf(element), 1);
    });

    const anchorIndex = allElements.findIndex(
      element =>
        element.attribute_display_name === anchorLabel ||
        element.label === anchorLabel
    );

    if (operation === 'replace') {
      if (anchorIndex === -1) allElements.push(...movableElements);
      else allElements.splice(anchorIndex, 1, ...movableElements);
    } else if (anchorIndex !== -1) {
      allElements.splice(anchorIndex + 1, 0, ...movableElements);
    } else {
      allElements.push(...movableElements);
    }
  });

  return allElements;
};
